import { Injectable } from '@angular/core';
import { HttpRequestService } from './api/http-request.service';
import { environment } from '@environments/environment';
import { RequestResponse } from './api/interfaces/request.interface';
import { Observable, of, tap } from 'rxjs';
import { transformJsonToFormData } from '@utilities/transform-json-to-form-data';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService extends HttpRequestService {

  private url = "auth";
  private permissions: string[] | null = null;

  constructor() {
    super();
    this.getToken();
  }

  public postTokenClient(body: { username: string; password: string; }): Observable<RequestResponse>{
    const clientBody = {
      ...body,
      api_username: environment.api_username,
      api_password: environment.api_password
    }

    return this.postUser(`${this.url}/client/login`, clientBody);
  }

  public postSendOtp(body: {otp_type: number, user_id: number, session_code: string; }): Observable<RequestResponse>{
    return this.postUser(`${this.url}/client/login/otp`, body);
  }

  public postValidateOtp(body: {user_id: string; otp: string; session_code: string }): Observable<RequestResponse>{
    return this.postUser(`${this.url}/client/login/otp/validation`, body);
  }

  public saveToken(token: string){
    localStorage.setItem('token-logidec', token);
  }

  public isExternalAccess(): boolean {
    return localStorage.getItem('logidec-external-access') === '1';
  }

  public clearExternalAccess(): void {
    localStorage.removeItem('logidec-external-access');
  }

  public getToken(): string | null {
    return localStorage.getItem('token-logidec');
  }

  public saveRefreshToken(token: string): void {
    localStorage.setItem('refresh-token', token);
  }

  public refreshToken(): Observable<RequestResponse>{
    const body = {
      user: localStorage.getItem('name'),
      token: this.getToken()
    }
    return this.postUser(`${this.url}/client/refresh`, body);
  }

  public getUserPermissions(): Observable<RequestResponse>{
    return this.get(`users/permissions`).pipe(
      tap((res: any) => {
        this.permissions = res?.data?.permissions_list ?? [];
      })
    );
  }

  public loadPermissions(): Observable<string[]>{
    if (this.permissions) {
      return of(this.permissions);
    }

    return new Observable<string[]>(observer => {
      this.getUserPermissions().subscribe({
        next: (res: any) => {
          observer.next(res?.data?.permissions_list ?? []);
          observer.complete();
        },
        error: err => observer.error(err)
      });
    });
  }

  public hasPermission(permission: string): boolean {
    return this.permissions?.includes(permission) ?? false;
  }

  public hasAnyPermission(permissions: string[]): boolean {
    return permissions.some(permission => this.hasPermission(permission));
  }

  public hasOnlyModule(module: string): boolean {
    if (!this.permissions?.length) {
      return false;
    }

    return this.permissions.every(permission => permission.startsWith(`${module}:`));
  }

  public cleanUpToken(){
    localStorage.removeItem('token-logidec');
    this.permissions = null;
  }

  public override logout(){
    localStorage.clear();
    this.permissions = null;
    this.router.navigate(['/auth/iniciar-sesion'])
  }

  userData: {initial: string, name: string} = {initial: '', name: ''};

  public set setUserData(data: {initial: string, name: string}){
    localStorage.setItem('initial', data.initial);
    localStorage.setItem('name', data.name);
  }

  public get getUserData(){
    this.userData = {initial: localStorage.getItem('initial') ?? '', name: localStorage.getItem('name') ?? ''}
    return this.userData;
  }

}
